import React, {useState} from "react";
import {Box, Icon} from "react-bulma-components";
import { Heading, Form } from "react-bulma-components";
import { Columns } from "react-bulma-components";
import Figure from "./Figure";
import { useFiguresData } from "../../hooks/useFiguresData";
import {useDispatch, useSelector} from "react-redux";
import {
  getTransactionFiguresData,
  getPartFiguresData,
  getWorkFiguresData,
  getRentalFiguresData,
  getVehicleFiguresData,
  getTargetFiguresData,
  getHomeTotalsData,
  getCapTotalsData,
  getVehicleSummaryData,
  getVehicleSummaryFiguresData,
  getPartOrderFigureData, getMovementFiguresData
} from "../../state/selectors";
import TransactionsSummary from "./TransactionsSummary";
import {createSetDataFreshAction, createSetTotalsDataAction} from "../../actions/dataActions";
import axios from "axios";
import {NotificationManager} from "react-notifications";
import useInlineEditButton from "../../hooks/useInlineEditButton";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPoundSign} from "@fortawesome/free-solid-svg-icons";
import {TotalValues} from "../Vehicle/View/CapTotals";
import {VehicleSummaryColumns} from "../Vehicle/View/VehicleTotals";
import WorkshopFigures from "./WorkshopFigures";
import RentalFigures from "./RentalFigures";
import PartOrderFigures from "./PartOrderFigures";
import MovementFigures from "./MovementFigures";
import VehicleFigures from "./VehicleFigures";
import TransactionFigures from "./TransactionFigures";
import FigureTotals from "./FigureTotals";

function Figures(props) {

  let params = {
    start: props.dates.start,
    end: props.dates.end,
    type: props.dates.type,
    department: props.selectedDepartment
  }
  const complete = useFiguresData(params);

  const getWorkshopIncome = (part, work) => {
    let total = part.data.total_customer_charge + work.data.total_customer_cost;
    return Math.round( (total * 100) ) / 100
  }

  const getWorkshopExpense = (part, work) => {
    let total = part.data.total_cost + work.data.total_cost;
    return Math.round( (total * 100) ) / 100
  }

  const getRentalIncome = (rental) => {
    let total = rental.data.total_long_term_income + rental.data.total_short_term_income;
    return Math.round( (total * 100) ) / 100;
  }

  const getPartOrderProfit = (partOrder) => {
    let total = partOrder.data.total_part_order_customer_cost - partOrder.data.total_part_order_cost;
    return Math.round( (total * 100) ) / 100;
  }

  const getTotalIncome = () => {
    let total = data.part.data.total_customer_charge + data.work.data.total_customer_cost + getRentalIncome(data.rentals) +
        data.partOrder.data.total_part_order_customer_cost + data.transactions.data.total_income + data.vehicles.data.total_sales_profit + data.movement.data.total;
    return Math.round( (total * 100) ) / 100
  }

  const getTotalExpenseCF = () => {
    let total = data.part.data.total_cost + data.work.data.total_cost + data.vehicles.data.total_tax + data.vehicles.data.total_finance +
        data.transactions.data.total_expense + data.partOrder.data.total_part_order_cost + data.transactions.data.fixed_expense;
    return Math.round( (total * 100) ) / 100
  }

  const getTotalExpensePNL = () => {
    let total = data.work.data.total_cost + data.part.data.total_cost + data.vehicles.data.total_tax + data.vehicles.data.total_depreciation +
        data.vehicles.data.total_hp_interest_accrued + data.transactions.data.total_expense + data.partOrder.data.total_part_order_cost;
    return Math.round( (total * 100) ) / 100
  }

  const getWorkshopProfit = (part, work) => {
    let total = getWorkshopIncome(part, work) - getWorkshopExpense(part, work);
    return Math.round( (total * 100) ) / 100
  }

  const getProfitCF = () => {
    let total = getTotalIncome() - getTotalExpenseCF();
    return Math.round( (total * 100) ) / 100
  }

  const getProfitCFVSTarget = () => {
    let target = data.target.data.weekly_target ? data.target.data.weekly_target : 0
    let total = getProfitCF() - target;
    return Math.round( (total * 100) ) / 100
  }

  const getProfitPNL = () => {
    return Math.round( ((getTotalIncome() - getTotalExpensePNL())*100) ) / 100;
  }

  const data = {
    transactions: {
      loaded: complete.transactionsLoading,
      data: useSelector(getTransactionFiguresData)
    },
    work: {
      loaded: complete.workLoading,
      data: useSelector(getWorkFiguresData)
    },
    part: {
      loaded: complete.partsLoading,
      data: useSelector(getPartFiguresData)
    },
    rentals: {
      loaded: complete.rentalsLoading,
      data: useSelector(getRentalFiguresData)
    },
    vehicles: {
      loaded: complete.vehiclesLoading,
      data: useSelector(getVehicleFiguresData)
    },
    vehicleSummary: {
      loaded: complete.vehicleSummaryLoaded,
      data: useSelector(getVehicleSummaryFiguresData)
    },
    target: {
      loaded: complete.targetsLoading,
      data: useSelector(getTargetFiguresData)
    },
    cap: {
      loaded: complete.capLoaded,
      data: useSelector(getCapTotalsData)
    },
    partOrder: {
      loaded: complete.partOrderLoaded,
      data: useSelector(getPartOrderFigureData)
    },
    movement: {
      loaded: complete.movementLoaded,
      data: useSelector(getMovementFiguresData)
    }
  };

  const all_loaded =
    data.transactions.loaded &&
    data.vehicles.loaded &&
    data.rentals.loaded &&
    data.part.loaded &&
    data.work.loaded &&
    data.target.loaded &&
    data.cap.loaded &&
    data.vehicleSummary.loaded &&
    data.partOrder.loaded &&
    data.movement.loaded;

  // const onTotalsChange = (e, index) => {
  //     let newTotals = {...data.totals.data.results}
  //     newTotals[index][e.target.name] = e.target.value;
  //     dispatch(createSetTotalsDataAction(newTotals));
  // }
  //
  // const onTotalsSave = (data) => {
  //   let url = props.endpoint+`homepagetotal/${data.id}`
  //   const conf = {
  //     url,
  //     method: "put",
  //     data
  //   }
  //   axios(conf).then(() => {
  //     //dispatch(createSetDataFreshAction(props.dataFresh+1))
  //     setEditable(false);
  //   }).catch(err =>{
  //     NotificationManager.error("There was an error")
  //   })
  // }


  return (
    <Box>
      <WorkshopFigures
          workData={data.work.data}
          workLoaded={data.work.loaded}
          partsData={data.part.data}
          partLoaded={data.part.loaded}
          profit={(data.part.loaded && data.work.loaded) ? getWorkshopProfit(data.part, data.work) : 0}
      />
      <RentalFigures
        rentalsData={data.rentals.data}
        rentalsLoaded={data.rentals.loaded}
        totalIncome={data.rentals.loaded ? getRentalIncome(data.rentals) : 0}
      />
      <PartOrderFigures
        partOrderData={data.partOrder.data}
        partOrdersLoaded={data.partOrder.loaded}
        totalProfit={data.partOrder.loaded ? getPartOrderProfit(data.partOrder) : 0}
      />
      <MovementFigures
        movementLoaded={data.movement.loaded}
        movementData={data.movement.data}
      />
      <VehicleFigures
        vehiclesData={data.vehicles.data}
        vehicleSummaryData={data.vehicleSummary.data}
        capData={data.cap.data}
        vehiclesLoaded={data.vehicles.loaded}
        vehicleSummaryLoaded={data.vehicleSummary.loaded}
        capLoaded={data.cap.loaded}
      />
      <TransactionFigures
        data={data.transactions.data}
        loaded={data.transactions.loaded}
      />
      <FigureTotals
        allLoaded={all_loaded}
        totalIncome={all_loaded ? getTotalIncome() : 0}
        totalExpenseCF={all_loaded ? getTotalExpenseCF() : 0}
        totalProfitCF={all_loaded ? getProfitCF() : 0}
        target={(all_loaded && data.target.data.weekly_target) ? data.target.data.weekly_target : 0}
        profitVSTarget={all_loaded ? getProfitCFVSTarget() : 0}
        totalExpensePNL={all_loaded ? getTotalExpensePNL() : 0}
        totalProfitPNL={all_loaded ? getProfitPNL() : 0}
      />
    </Box>
  );
}

export default Figures;
